import React from "react";
import ProjectCard from "../components/ProjectCard";
import projects from "../data/projects";
import usePageMeta from "../hooks/usePageMeta";
import useScrollReveal from "../hooks/useScrollReveal";

function PortfolioPage() {
  usePageMeta({
    title: "Portfolio",
    description:
      "Une sélection de projets réalisés par Sofiane Amroune, de la conception de l’interface à la mise en production.",
  });

  const { ref: heroRef, revealProps: heroRevealProps } = useScrollReveal({
    triggerOnce: true,
    threshold: 0.15,
  });
  const { ref: projectsRef, revealProps: projectsRevealProps } = useScrollReveal({
    triggerOnce: true,
    threshold: 0.08,
  });

  return (
    <div className="page-shell space-y-8 lg:space-y-10">
      <section
        ref={heroRef}
        {...heroRevealProps}
        className="hero-panel scroll-reveal"
      >
        <span className="eyebrow">Portfolio</span>
        <h1>Quelques projets réalisés</h1>
        <p className="mt-5 max-w-3xl text-lg leading-8 text-muted sm:text-xl">
          Une sélection de projets permettant de découvrir concrètement mon travail en
          développement web, de la conception de l’interface jusqu’à la mise en production.
        </p>
      </section>

      <section
        ref={projectsRef}
        {...projectsRevealProps}
        aria-label="Projets réalisés"
        className="scroll-reveal grid gap-6 lg:grid-cols-2"
      >
        {projects.map((project) => (
          <ProjectCard key={project.slug} project={project} />
        ))}
      </section>
    </div>
  );
}

export default PortfolioPage;
